export const ASSISTANT_PATH = '/assistant';

export const CREW_PAGE_SIZE = 5;

export const HINT_CHIPS = ['Drivers', 'Routes', 'Rides', 'Incidents'];

export const DEMO_CREW_MEMBER = {
	id: 'DR-1042',
	fullName: 'Marco Bauer',
	driverCard: 'DE-BY-2034891',
	isActive: true,
	phone: '+49 89 12345678',
	email: 'marco.bauer@flixbus.com',
	currentHomeBase: {
		id: 'hb-muc-d1',
		effectiveTimestamp: '2022-03-01T08:00:00Z',
		city: { name: 'Munich', timezone: 'Europe/Berlin' },
	},
	permanentHomeBase: {
		id: 'hb-muc-d1',
		effectiveTimestamp: '2022-03-01T08:00:00Z',
		city: { name: 'Munich' },
	},
	currentLocation: {
		city: { name: 'Munich' },
		station: { name: 'Munich Central Bus Station', code: 'MUC' },
		fromTimestamp: '2025-10-12T06:30:00Z',
	},
	currentRun: { id: 'run-201', name: 'MUC → FRA Line 08' },
	currentJobs: [{ id: 'j-501', code: 'DRV-501' }],
	currentEmploymentType: {
		id: 'emp-1',
		employmentType: 'fullTime',
		effectiveTimestamp: '2022-03-01T00:00:00Z',
	},
	driverLicenseExpiresAt: '2027-08-15',
	drugTestExpiresAt: '2026-03-01',
	medicalCheckExpiresAt: '2026-11-20',
	nextAvailability: '2025-10-13T06:00:00Z',
	hoursTracking: {
		drivingMinutesBalance: 240,
		drivingMinutesLimit: 540,
		dutyMinutesBalance: 300,
		dutyMinutesLimit: 660,
		eightDaysDutyMinutesBalance: 1800,
		eightDaysDutyMinutesLimit: 3600,
	},
	lastWorkAssignment: {
		fromTimestamp: '2025-10-12T06:30:00Z',
		toTimestamp: '2025-10-12T14:00:00Z',
		activity: {
			fromStation: { name: 'Munich Central Bus Station', code: 'MUC' },
			toStation: { name: 'Frankfurt (Main) Bus Station', code: 'FRA', city: { name: 'Frankfurt' } },
		},
	},
	holdDowns: [],
};

export const HISTORY_GROUPS = [
	{
		label: 'Today',
		items: [
			{
				id: 'h1',
				title: 'Driver Marco Bauer details',
				preview: 'Show me details for Marco Bauer',
				time: '09:43',
			},
			{
				id: 'h2',
				title: 'MUC → FRA trip summary',
				preview: 'How many trips last week on MUC-FRA?',
				time: '08:15',
			},
		],
	},
	{
		label: 'Yesterday',
		items: [
			{
				id: 'h3',
				title: 'Drivers on leave',
				preview: 'List all drivers currently on leave',
				time: '17:30',
			},
			{
				id: 'h4',
				title: 'Revenue report Oct',
				preview: 'October revenue breakdown by route',
				time: '14:02',
			},
		],
	},
	{
		label: 'This week',
		items: [
			{
				id: 'h5',
				title: 'Delayed routes Oct 8',
				preview: 'Which routes had delays over 20 min?',
				time: 'Oct 8',
			},
			{
				id: 'h6',
				title: 'New driver onboarding',
				preview: 'Drivers onboarded this month',
				time: 'Oct 7',
			},
		],
	},
];

export const SUGGESTED_QUERIES = [
	'Driver details',
	'Route performance',
	'Active incidents',
	'Trip summary',
];
